import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-compass-3-line text-3xl text-accent"></i>
              </div>
              <div>
                <div className="font-bold text-xl text-primary">RUMBO</div>
                <div className="text-xs text-secondary font-medium tracking-wider">
                  MARKETING
                </div>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#servicios"
                className="text-sm font-medium text-primary hover:text-accent transition-colors whitespace-nowrap cursor-pointer"
              >
                Servicios
              </a>
              <a
                href="#proceso"
                className="text-sm font-medium text-primary hover:text-accent transition-colors whitespace-nowrap cursor-pointer"
              >
                Cómo trabajamos
              </a>
              <a
                href="#fundadora"
                className="text-sm font-medium text-primary hover:text-accent transition-colors whitespace-nowrap cursor-pointer"
              >
                Sobre nosotros
              </a>
              <a
                href="#contacto"
                className="text-sm font-medium text-primary hover:text-accent transition-colors whitespace-nowrap cursor-pointer"
              >
                Contacto
              </a>
              <button
                onClick={() => scrollToSection('contacto')}
                className="bg-accent hover:bg-accent-dark text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                Coordinar reunión
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-primary hover:text-accent transition-colors"
              aria-label="Toggle menu"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 bg-primary z-40 transform transition-transform duration-300 ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full space-y-8">
          <a
            href="#servicios"
            onClick={() => setIsMenuOpen(false)}
            className="text-2xl font-medium text-white hover:text-accent transition-colors cursor-pointer"
          >
            Servicios
          </a>
          <a
            href="#proceso"
            onClick={() => setIsMenuOpen(false)}
            className="text-2xl font-medium text-white hover:text-accent transition-colors cursor-pointer"
          >
            Cómo trabajamos
          </a>
          <a
            href="#fundadora"
            onClick={() => setIsMenuOpen(false)}
            className="text-2xl font-medium text-white hover:text-accent transition-colors cursor-pointer"
          >
            Sobre nosotros
          </a>
          <a
            href="#contacto"
            onClick={() => setIsMenuOpen(false)}
            className="text-2xl font-medium text-white hover:text-accent transition-colors cursor-pointer"
          >
            Contacto
          </a>
          <button
            onClick={() => {
              setIsMenuOpen(false);
              scrollToSection('contacto');
            }}
            className="bg-accent hover:bg-accent-dark text-white px-8 py-3 rounded-lg text-lg font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            Coordinar reunión
          </button>
        </div>
      </div>
    </>
  );
}
